import { type FunctionComponent } from "react";

import { Container, PlaceholderBar } from "./styles";

export type AiWidgetPlaceholderProps = {
  className?: string;
};

/**
 * Shared placeholder shown while the AI recommendation fetch / fallback query
 * is in flight. Used for all 4 widget areas (Package Top, Open Question, CFT,
 * Spotlight).
 */
export const AiWidgetPlaceholder: FunctionComponent<AiWidgetPlaceholderProps> = ({ className }) => (
  <Container className={className}>
    <PlaceholderBar $height={20} $width="40%" />
    <PlaceholderBar $height={14} $width="100%" />
    <PlaceholderBar $height={14} $width="100%" />
    <PlaceholderBar $height={14} $width="80%" />
  </Container>
);

AiWidgetPlaceholder.displayName = "AiWidgetPlaceholder";
